import http from "../utils/http-common";

const baseProductionPath = "api/production";

export const getYear = () => {
  return http.get(`${baseProductionPath}/year`);
};

export const getProduction = (query: string) => {
  return http.get(`${baseProductionPath}${query}`);
};

export const updateProduction = (data: any, year: number) => {
  return http.patch(`${baseProductionPath}/update-production-data/${year}`, data);
};
